export const MxEnumerados = {
	getCondicaoContainer,
};

function getCondicaoContainer(condicao) {
	switch (condicao) {
		case 0:
			return "Cheio";
		case 1:
			return "Vazio";
		case 2:
			return "Nenhum";
		case 3:
			return "Em desova";
		case 4:
			return "Em estufagem";
		case 5:
			return "Com mercadoria";
		case 6:
			return "Correcao desova";
		case 7:
			return "Correcao estufagem";
		case 8:
			return "Desova Interrompida";
		case 9:
			return "Estufagem Interrompida";
		default:
			return "";
	}
}

export const EnumTiposEtiqueta = Object.freeze({
    NaoFormatado: 1,
    Formatado: 2
});

export const EActiveField = Object.freeze({
    Volume: 0,
    QuantidadeRegular: 1,
    ContraMarca: 2,
    Peso: 3
});